import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";

export function* handleFetchLabStatuses({ data }) {

  try {
    const response = yield axios.get(`${baseURL}/lab-status`, {
    });
    if (response.status === 200) {
      yield put(actions.fetchLabStatusesSuccess(response.data));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchLabStatusesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateLabStatuses({ data }) {
  const { color, id, showByDefault, statusName } = data;
  try {
    const response = yield axios.patch(
      `${baseURL}/lab-status/${id}`,
      {
        showByDefault,
        statusName,
        color,
      }
    );
    if (response.status === 200) {
      AntdAlert.success("Lab Status Updated Successfully");
      yield put(actions.updateLabStatusesSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateLabStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateLabStatusesError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteLabStatuses({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/lab-status/${id}`
    );

    if (response.status === 200) {
      AntdAlert.success("Lab Status Deleted Successfully");
      yield put(actions.deleteLabStatusesSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteLabStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteLabStatusesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateLabStatuses({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    const response = yield axios.post(`${baseURL}/lab-status`, {
      ...newData,
    });
    if (response.status === 201) {
      AntdAlert.success("Lab Status Created Successfully");
      yield put(actions.createLabStatusesSuccess(response.data));
      console.log(response.data);
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createLabStatusesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateLabOrder({ data }) {
  const labStatusObj = {};

  data.forEach((el, i) => {
    labStatusObj[el.id] = i;
  });

  const payload = {
    labStatus: labStatusObj
  };
  try {
    const response = yield axios.post(
      `${baseURL}/lab-status/sort`,
      payload
    );

    if (response.status === 201) {
      AntdAlert.success("Lab Status Order Updated Successfully");
      yield put(actions.updateLabsOrderSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateLabsOrderError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateLabsOrderError());
    // AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
